<div class="cards-container">
  <!-- toodo with real resp: use trackBy _id: "64f0d33930019285e0e23cc6" so that duplicate properties are not re-fetched -->
  <!-- todo use card instead of separate skeleton card so that trnsitioning in and out isnt as choppy -->
  <ng-container *ngIf="hostels">
    <!-- todo on first render, pass in an app card that -->
    <ng-container *ngFor="let hostel of hostels; let i = index; trackBy: trackById">
      <app-card [hostel]="hostel" [skeleton]="skeleton || !hostel._id" [currency]="currency | async" [i]="i" (click)="navigateToHostelDetails(hostel)"></app-card>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="skeleton">
    <app-skeleton-card *ngFor="let hostel of mockHostels" @fadeIn></app-skeleton-card>
  </ng-container>
</div>
